import type { FacilityHour } from 'src/app/types';
import { WEEK } from 'src/consts';

export const formatHours = (hours: FacilityHour[]) => {
  const weekdayHours = hours?.slice(0, 5);
  const weekendHours = hours?.slice(5);
  const formatted = {
    [WEEK.DAYS]: transformCurrentDayHours(weekdayHours?.[0]?.formattedHours),
  };
  if (weekendHours?.length === 2) {
    if (weekendHours?.[0].formattedHours === weekendHours?.[1].formattedHours) {
      formatted[WEEK.ENDS] = transformCurrentDayHours(weekendHours?.[0]?.formattedHours);
    } else {
      formatted[WEEK.SATURDAY] = transformCurrentDayHours(weekendHours?.[0]?.formattedHours);
      formatted[WEEK.SUNDAY] = transformCurrentDayHours(weekendHours?.[1]?.formattedHours);
    }
  }

  return formatted;
};

/**
 * Formats hours string from BFF for Contact Us page hours.
 *
 * @example
 * // returns `8am-9am`
 * transformCurrentDayHours('8 AM - 9 AM');
 *
 * @param {string} currentHours The current day's operational hours from BFF.
 * @return {string} Formatted operational hours with no spaces and only lowercase letters.
 */
function transformCurrentDayHours(currentHours: string) {
  if (currentHours === 'Closed') return currentHours;
  return currentHours?.replace(/\s+/g, '')?.toLowerCase();
}
